import React from 'react'
import {
    defaultCountries,
    FlagImage,
    parseCountry,
    usePhoneInput,
} from 'react-international-phone';
import "react-international-phone/style.css";
import {

    Select,
    TextField,
    MenuItem,
    InputAdornment,
    Typography,
} from "@mui/material";

const MuiPhone = ({ value, onChange, phoneCountry, onCountryChange, ...restProps }) => {

    console.log(phoneCountry, "phoneCountry")
    const { inputValue, handlePhoneValueChange, inputRef, country, setCountry } =
        usePhoneInput({
            defaultCountry: phoneCountry || 'IN',
            value,
            countries: defaultCountries,
            onChange: (data) => {
                onChange(data.phone);
            },
        });

     // Prevent backspace from deleting country code
    const handleKeyDown = (e) => {
        const input = e.target;
        // If backspace is pressed and cursor is at or before the end of country code (e.g., "+91" = 3 chars)
        // dialCode.length + 1 accounts for the "+" sign
        if (e.key === 'Backspace' && input.selectionStart <= country.dialCode.length + 1) {
            e.preventDefault();
        }
    };

    // Handle input changes while preventing country code modification
    const handleChange = (e) => {
        const inputValue = e.target.value;
        // Only proceed with the change if the country code is still present
        if (inputValue.startsWith(`+${country.dialCode}`) || inputValue === '') {
            handlePhoneValueChange(e);
        } else {
            // If country code was modified, revert to the original value with correct country code
            const phoneInput = inputRef.current;
            const cursorPosition = phoneInput.selectionStart;
            const newValue = `+${country.dialCode}${inputValue.replace(/\D/g, '')}`;
            
            // Update the input value manually
            phoneInput.value = newValue;
            
            // Restore cursor position
            setTimeout(() => {
                phoneInput.setSelectionRange(cursorPosition, cursorPosition);
            }, 0);
        }
    };

    // When user selects a new country, update both local and parent
    const handleCountryChange = (e) => {
        setCountry(e.target.value);
        if (onCountryChange) {
            onCountryChange(e.target.value);
        }
    };

    return (
        <TextField
            className="phone-input-mui"
            variant="outlined"
            color="primary"
            placeholder="Phone number"
            value={inputValue}
            onChange={handleChange}
            onKeyDown={handleKeyDown}
            type="tel"
            inputRef={inputRef}
            fullWidth
            InputProps={{
                startAdornment: (
                    <InputAdornment
                        position="start"
                        style={{ marginRight: '2px', marginLeft: '-8px' }}
                    >
                        <Select
                            MenuProps={{
                                style: {
                                    height: '300px',

                                    top: '10px',
                                    left: '-34px',
                                },
                                transformOrigin: {
                                    vertical: 'top',
                                    horizontal: 'left',
                                },
                            }}
                            sx={{

                                fieldset: {
                                    display: 'none',
                                },
                                '&.Mui-focused:has(div[aria-expanded="false"])': {
                                    fieldset: {
                                        display: 'block',
                                    },
                                },
                                // Update default spacing
                                '.MuiSelect-select': {
                                    padding: '8px',
                                    paddingRight: '24px !important',
                                },
                                svg: {
                                    right: 0,
                                },
                            }}
                            value={country.iso2}
                            onChange={handleCountryChange}
                            renderValue={(value) => (
                                <FlagImage iso2={value} style={{ display: 'flex' }} />
                            )}
                        >
                            {defaultCountries.map((c) => {
                                const country = parseCountry(c);
                                return (
                                    <MenuItem key={country.iso2} value={country.iso2}>
                                        <FlagImage
                                            iso2={country.iso2}
                                            style={{ marginRight: '8px' }}
                                        />
                                        <Typography marginRight="8px">{country.name}</Typography>
                                        <Typography color="gray">+{country.dialCode}</Typography>
                                    </MenuItem>
                                );
                            })}
                        </Select>
                    </InputAdornment>
                ),
            }}
            {...restProps}
        />
    );
};

export default MuiPhone;    